/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* eslint-disable no-duplicate-imports */

import MsDyn365 from '@msdyn365-commerce/core';
import { Button, IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';
import { ICittaProductAttributeCompanionProductData } from './citta-product-attribute-companion-product.data';
import { ICittaProductAttributeCompanionProductProps } from './citta-product-attribute-companion-product.props.autogenerated';

export interface ICittaProductAttributeCompanionProductViewProps extends ICittaProductAttributeCompanionProductProps<ICittaProductAttributeCompanionProductData> {
  linkItem?: INodeProps;
  className?: string;
  contentBlockContainer: IModuleProps;
}
/**
 *
 * ContentCard component
 * @extends {React.PureComponent<ICittaProductAttributeCompanionProductPropsICittaProductAttributeCompanionProductData>}
 */

class CittaProductAttributeCompanionProduct extends React.PureComponent<ICittaProductAttributeCompanionProductProps<ICittaProductAttributeCompanionProductData>> {
  //const attributeName
  public render(): JSX.Element | null {
    const {
     className
   } = this.props.config;

   const content: ICittaProductAttributeCompanionProductData = this.props.data;

   const attributes = content.attributes.result;
   const linkAttribute = attributes?.find(attribute => attribute.Name === this.props.config.attributeName);
   if (!linkAttribute || !linkAttribute.TextValue) {
     return null;
   }

   const attribute = linkAttribute.TextValue.split('|');
   const attributeName = attribute[0];
   const attributeLink = attribute[1];

   const contentBlockviewProps = {
     ...this.props,
     linkItem: this._renderLink(attributeLink, attributeName),
     contentBlockContainer: {
       moduleProps: this.props,
       className: classnames('product-attribute-companion-product', className),
     }
   };
   return this.props.renderView(contentBlockviewProps) as React.ReactElement;
 }

 private _renderLink = (linkUrl: String, attributeName: String) => {
   return (
    <Button
        className={`product-attribute-companion-product__button`}
        color='primary'
        onClick={() => this._goToLink(linkUrl)}
    >
      {attributeName}
    </Button>
   )
 };

 private _goToLink = (linkUrl: String) => {
   if (MsDyn365.isBrowser && typeof window !== 'undefined') {
     const baseUrl = window.location.origin;
     if (baseUrl.length) {
       window.location.assign(`${baseUrl}/${linkUrl}`);
     }
   }
 }
}

export default CittaProductAttributeCompanionProduct;
